import { render, staticRenderFns } from "./UpdateV1BandwidthLinesModal.vue?vue&type=template&id=4b6ace10&scoped=true&"
import script from "./UpdateV1BandwidthLinesModal.vue?vue&type=script&lang=js&"
export * from "./UpdateV1BandwidthLinesModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateV1BandwidthLinesModal.vue?vue&type=style&index=0&id=4b6ace10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ace10",
  null
  
)

export default component.exports